real.events.on('ai:synopsis:completed', notification => {
    const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${notification.object.uploaded_file.id}"] .card-content`);
    if (transcriptContainer.length === 0) {
        return;
    }
    const synopsisContainer = transcriptContainer.find('.synopsis-view-content');
    const text = notification.object.synopsis?.content ? notification.object.synopsis.content.trim() : '';

    howspace.animate(synopsisContainer, 'fadeOut', 'fast', () => {
        synopsisContainer.removeClass('d-none');
        synopsisContainer.text(text);
        // Re-enable the translation feature, in case the synopsis didn't exist at the time of the initial rendering.
        if (
            notification.object.synopsis?.content &&
            howspace.components.translator.isEnabled() &&
            !synopsisContainer.hasClass('translatable')
        ) {
            synopsisContainer.addClass('translatable translatable-block')
            synopsisContainer.dataAndAttr('t9n-type', 'synopsis');
            synopsisContainer.dataAndAttr('t9n-id', notification.object.synopsis.id);
        }
        howspace.animate(synopsisContainer, 'fadeIn', 'fast', () => {
            synopsisContainer.removeClass('translated');
            howspace.components.translator.init(synopsisContainer);
        });
    });

});
